import { render } from "./DocumentError.vue?vue&type=template&id=65ebb844"
const script = {}

import "./DocumentError.vue?vue&type=style&index=0&id=65ebb844&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__